'use strict';

angular.module('amexReconciliationApp')
  .directive('bcaDropdown', function () {
    return {
      scope: {},
      templateUrl: 'scripts/views/directives/bca-dropdown.html',
      controller: function ($scope, UserModel, TransactionSearchModel) {
        $scope.bcas = UserModel.bcas;
        $scope.currentBca = TransactionSearchModel.bca;
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/bcaDropdown.js
// module id = 513
// module chunks = 0